const home = {
  title: 'Početna',
  language: 'Jezik',
  allLanguages: 'Svi jezici',
  languageFilter: 'Filtriraj po jeziku',
  languagesSelected: '{{count}} odabranih',
  languages: {
    en: 'Engleski',
    sl: 'Slovenski',
    hr: 'Hrvatski',
  },

  loadingTemplates: 'Učitavam predloške...',
  noTemplates: 'Nema predložaka',
  noTemplatesForLanguage: 'Nema predložaka za ovaj jezik',
  noTemplatesForLanguageDescription:
    'Za početak, stvorite predložak na ovom jeziku.',
  selectTemplate: 'Odaberite predložak',
  selectTemplateDescription: 'Koji predložak želite koristiti za diktiranje?',

  start: 'Započni diktiranje',
  dropAudioHere: 'Ispustite audio datoteku ovdje',
  uploadAudio: 'Prenesi zvuk',
  uploadAndGenerate: 'Prenesi i generiraj',
  uploading: 'Prijenos...',
  uploadingAndGenerating: 'Prijenos...',
  stop: 'Zaustavi',
  saving: 'Spremam...',
  delete: 'Izbriši',

  resume: 'Nastavi diktiranje',
  cancel: 'Odustani',
  continue: 'Nastavi',
  transcription: 'Transkript',
  transcriptionEmpty: 'Još nema transkripcije',
  segmentBreaks: 'Prekidi segmenta',
  paused: 'Pauzirano',
  extractData: 'Generiraj nalaz',
  extractingData: 'Generiram podatke',
  extractingDataDescription: 'Ovo ne bi trebalo dugo trajati...',
  transcribingData: 'Transkripcija zvuka',
  transcribingDataDescription: 'Pretvaranje zvuka u tekst...',

  errorLoadingTemplates: 'Došlo je do pogreške prilikom učitavanja predložaka',
  retry: 'Pokušaj ponovno',
  createTemplate: 'Stvori predložak',

  stats: {
    word: 'riječ',
    words: 'riječi',
    character: 'znak',
    characters: 'znakova',
    token: 'token',
    tokens: 'tokena',
  },

  sectionGuidance: {
    analyzing: 'Analiziram...',
    suggestion: 'Prijedlog',
    analysisFailed: 'Analiza odjeljaka nije uspjela',
    analysisFailedDescription:
      'Nije moguće analizirati odjeljke. Snimanje će nastaviti.',
  },

  errors: {
    networkNotConnected: {
      title: 'Nema internetske veze',
      description: 'Za korištenje aplikacije potrebna je internetska veza.',
    },
    get_user_media_failed: {
      title: 'Pristup mikrofonu odbijen',
      description:
        'Za nastavak, omogućite pristup mikrofonu u postavkama preglednika.',
    },
    api_key_fetch_failed: {
      title: 'Autentifikacija nije uspjela',
      description:
        'Nismo mogli potvrditi vašu sesiju. Osvježite stranicu i pokušajte ponovno.',
    },
    queue_limit_exceeded: {
      title: 'Nestabilna mrežna veza',
      description:
        'Vaša internetska veza je prespora za prijenos zvuka u stvarnom vremenu. Transkripcija je prekinuta.',
    },
    websocket_error: {
      title: 'Veza prekinuta',
      description:
        'Veza sa serverom za transkripciju je izgubljena. Provjerite svoju internetsku vezu.',
    },
    media_recorder_error: {
      title: 'Pogreška prilikom snimanja',
      description:
        'Preglednik je neočekivano prekinuo snimanje. Pokušajte ponovno.',
    },
    api_error: {
      title: 'Serverska pogreška',
      description: 'Usluga transkripcije prijavila je pogrešku: {{message}}',
    },
    default: {
      title: 'Došlo je do pogreške',
      description: 'Nešto je pošlo po zlu. Pokušajte ponovno.',
    },
  },
};

export default home;
